function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.23 23.86a.62.62 0 01.16.4.72.72 0 01-.18.46.6.6 0 01-.86 0l-2.73-3.48v7.51a.61.61 0 01-1.21 0v-7.53l-2.76 3.48a.62.62 0 01-.81 0 .6.6 0 01-.09-.86L15 18.82l4.19 5zM10.82 5.75l4.18 5 4.23-5.09a.59.59 0 00-.09-.85.62.62 0 00-.81 0l-2.71 3.52V.84A.59.59 0 0015 .29a.6.6 0 00-.55.55v7.51l-2.77-3.48a.62.62 0 00-.86 0 .5.5 0 00-.18.46.54.54 0 00.15.4zm-8.66 7L15 14.12l12.85-1.41a.54.54 0 00.48-.61.55.55 0 00-.62-.49L15 13 2.27 11.61a.57.57 0 00-.62.49.58.58 0 00.51.61zm25.69 4l-12.8-1.41H15L2.14 16.72a.56.56 0 00-.49.62.54.54 0 00.62.48L15 16.44l12.74 1.38h.06a.54.54 0 00.55-.48.56.56 0 00-.5-.62z"
})));